export default __webpack_public_path__ + "static/media/mu.fe97046c.svg";